import {handleValidationChange} from '../CommonValidation';

export const validateEmployeeDeduction = (items, setIsError) => {
    var isValid = true;

    if(items.length < 1) {
        handleValidationChange("list", true, setIsError);
        isValid=false;
    } else {
        handleValidationChange("list", false, setIsError);
    }

    items.map((data) => {
        if(data.employee_id === "" || data.employee_id === null || data.employee_id === undefined) {
            handleValidationChange("employee_id", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("employee_id", false, setIsError);
        }
        if(data.amount === "" || parseFloat(data.amount) <= 0) {
            handleValidationChange("amount", true, setIsError);
            isValid=false;
        } else {
            handleValidationChange("amount", false, setIsError);
        }
    })


    return isValid
  
}

